var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-buttons"},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,staticClass:"button button-small button-round",class:{
      'button-binity-blue': option.value === _vm.value,
      'button-binity-blue--outline': option.value !== _vm.value,
    },on:{"click":function($event){return _vm.$emit('input', option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }